import { forwardRef } from "react";
import styles from "./ToggleSwitch.module.css";

const ToggleSwitch = forwardRef(
  (
    {
      checked = false,
      onChange,
      name,
      id,
      label,
      description,
      size = "md",
      disabled = false,
      className = "",
      ...props
    },
    ref
  ) => {
    const handleChange = (e) => {
      if (disabled) return;
      if (onChange) {
        onChange({ target: { name, checked: e.target.checked } });
      }
    };

    const wrapperClass = [
      styles.wrapper,
      disabled ? styles.disabled : "",
      className,
    ]
      .filter(Boolean)
      .join(" ");

    const trackClass = [
      styles.track,
      styles[size] || styles.md,
      checked ? styles.checked : "",
    ]
      .filter(Boolean)
      .join(" ");

    const thumbClass = [styles.thumb, styles[size] || styles.md]
      .filter(Boolean)
      .join(" ");

    return (
      <label htmlFor={id || name} className={wrapperClass}>
        <input
          ref={ref}
          type="checkbox"
          id={id || name}
          name={name}
          checked={checked}
          onChange={handleChange}
          disabled={disabled}
          className={styles.hiddenInput}
          role="switch"
          aria-checked={checked}
          {...props}
        />

        <span className={trackClass} aria-hidden="true">
          <span className={thumbClass} />
        </span>

        {(label || description) && (
          <div className={styles.textGroup}>
            {label && <span className={styles.label}>{label}</span>}
            {description && (
              <span className={styles.description}>{description}</span>
            )}
          </div>
        )}
      </label>
    );
  }
);

ToggleSwitch.displayName = "ToggleSwitch";

export default ToggleSwitch;
